const HIDE_ROUTE_NAMES = []
const HIDE_ROUTE_PATHS = ['quiz', 'register', 'cancel', 'checkout']

export default function (ctx) {
  ctx.app.router.afterEach(to => {
    const path = to.path.split('/')
    const hasRouteName = HIDE_ROUTE_NAMES.includes(to.name)
    const hasRoutePath =
      HIDE_ROUTE_PATHS.includes(path[1]) || HIDE_ROUTE_PATHS.includes(path[2])
    const status = hasRouteName || hasRoutePath ? 'hide' : 'show'

    setTimeout(() => {
      if (window.zE) {
        window.zE('webWidget', status)
      }
    }, 0)
  })

  if (!ctx.store.getters['user/customerId'] && window.zE) {
    window.zE('webWidget', 'logout')
  }
}
